import axios from 'axios';

const baseUrl = '/services/isnaportalsync/open-api/fno/nz001';
const authorizedBaseUrl = '/services/isnaportalsync/api/fno/nz001';

export const getNz001 = (params: string) => {
    return axios.get(baseUrl + params);
};
export const getNz001Authorized = (params: string, tokenStr: string) => {
    return axios.get(authorizedBaseUrl + params, {
        headers: { Authorization: `${tokenStr}` },
    });
};
